<template>
  <div class="portfolio">
    <button class="portfolio__sketchbook-1" @click="$emit('openModal', 'sketchbook_1')"
      aria-label="Button to open sketchbook"></button>
    <button class="portfolio__animation" @click="$emit('openModal', 'animation_reel')"
      aria-label="Button to open animation reel"></button>
    <button class="portfolio__gallery" @click="$emit('openModal', 'gallery_frames')"
      aria-label="Button to open gallery"></button>
  </div>
</template>

<script>
export default { name: 'Portfolio' };
</script>

<style lang="scss" scoped>
@import '../tools.mixins';

.portfolio{
  @include abs(0, 0, 1920px, 1920px);
  transform-origin: 0 0;
  background: url(../assets/bgd/portfolio.jpg) center no-repeat;
  background-size: cover;

  &__sketchbook-1{
    @include abs(589px, 750px, 441px, 441px);
    @include mouseoverButton(sketchbooks-mo);
  }
  &__animation{
    @include abs(841px, 486px, 420px, 337px);
    @include mouseoverButton(animation-mo);
  }
  &__gallery{
    @include abs(1058px, 990px, 130px, 250px);
    @include mouseoverButton(gallery-mo);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Portfolio.vue